import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import hexToRgbChannels from '../../assets/js/hexToRgbChannels';
import '../../assets/styles/PinnedSteps.css';

const Pin = () => (
  <svg
    className="pin-card__pin"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M16 3a1 1 0 0 1 .117 1.993l-.117 .007v4.764l1.894 3.789a1 1 0 0 1 .1 .331l.006 .116v2a1 1 0 0 1 -.883 .993l-.117 .007h-4v4a1 1 0 0 1 -1.993 .117l-.007 -.117v-4h-4a1 1 0 0 1 -.993 -.883l-.007 -.117v-2a1 1 0 0 1 .06 -.34l.046 -.107l1.894 -3.791v-4.762a1 1 0 0 1 -.117 -1.993l.117 -.007h8z" />
  </svg>
);

const PATH =
  'M 240 75 L 760 75 ' +
  'M 760 175 C 620 255, 420 230, 250 298 ' +
  'M 240 385 L 760 385';

const PinnedSteps = React.forwardRef(({ steps, className = '', ...props }, ref) => {
  const reduced = useReducedMotion() === true;

  return (
    <div ref={ref} className={`pinned ${className}`.trim()} {...props}>
      {steps.length > 1 && (
        <svg
          className="pinned__thread"
          viewBox="0 0 1000 510"
          preserveAspectRatio="none"
          aria-hidden="true"
        >
          <motion.path
            d={PATH}
            fill="none"
            strokeWidth="2"
            strokeDasharray="8 6"
            strokeLinecap="round"
            vectorEffect="non-scaling-stroke"
            initial={{ strokeDashoffset: 0 }}
            animate={reduced ? undefined : { strokeDashoffset: -140 }}
            transition={
              reduced
                ? undefined
                : { duration: 3, repeat: Infinity, ease: 'linear' }
            }
          />
        </svg>
      )}

      <ol className="pinned__list">
        {steps.map((step, index) => (
          <li
            key={step.id || index}
            className="pinned__item"
            style={{ '--pin-rgb': hexToRgbChannels(step.accent) || undefined }}
          >
            <article className="pin-card">
              <div className="pin-card__sheet">
                <Pin />
                <div className="pin-card__panel">
                  <span className="pin-card__number">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <p className="pin-card__text">{step.text}</p>
                </div>
              </div>
            </article>
          </li>
        ))}
      </ol>
    </div>
  );
});

PinnedSteps.displayName = 'PinnedSteps';

export default PinnedSteps;
export { PinnedSteps };
